import React, { FC } from 'react'

import { TargetPartner } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { capitalizeEachFirstLetter, CheckboxBasedFilter } from '@avantstay/backoffice-core'

import { FiltersSharedProps } from './Filters.types'

interface TargetPartnerFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
  options?: { value: string; label: string }[]
}

export const TargetPartnerFilter: FC<TargetPartnerFilterProps> = props => {
  const { options } = props

  const optionsToUse =
    options ||
    Object.keys(TargetPartner).map(targetPartner => ({
      value: TargetPartner[targetPartner as keyof typeof TargetPartner],
      label: capitalizeEachFirstLetter(
        TargetPartner[targetPartner as keyof typeof TargetPartner],
      ).replace(/_/g, ' '),
    }))

  return <CheckboxBasedFilter title="Target Partner" options={optionsToUse} {...props} />
}
